/**
 * AIChat · Context 透传 sizeClass / 容器宽度
 *
 * 对应文档：docs/AI-Photo-Category/TECH_PLAN.md §4.2.1
 *
 * 用途：
 *  · AIChat 子孙组件（ChatFeed / Composer / StepCard 等）按 sizeClass 做
 *    布局分支时，从 Context 取值，避免一路 prop drilling
 *
 * 默认值决策：
 *  · sizeClass 默认 'standard'（而非 'compact'），防止组件在 Provider 外
 *    被误用时呈现非预期的极窄布局
 */

import React, { createContext, useContext } from 'react'
import type { SizeClass } from '../../../../types/ai-classify'

export interface AIChatContextValue {
  /** 容器当前像素宽度 · 未测量前为 0 */
  width: number
  /** 派生 SizeClass */
  sizeClass: SizeClass
}

const DEFAULT_CONTEXT: AIChatContextValue = {
  width: 0,
  sizeClass: 'standard'
}

const AIChatContext = createContext<AIChatContextValue>(DEFAULT_CONTEXT)

/** Provider · 由 AIChat 组件内部使用，一般业务代码无需直接消费 */
export const AIChatProvider: React.FC<{
  value: AIChatContextValue
  children: React.ReactNode
}> = ({ value, children }) => (
  <AIChatContext.Provider value={value}>{children}</AIChatContext.Provider>
)

/** 消费 hook · 子孙组件按需取 sizeClass / width */
export function useAIChat(): AIChatContextValue {
  return useContext(AIChatContext)
}
